module.exports = ['country', 'national', 'zone', 'state', 'lga', 'sdp']
